function isNativePlatform(): boolean {
  try {
    const w: any = typeof window !== 'undefined' ? window : undefined;
    if (!w) return false;
    if (w.Capacitor?.isNativePlatform?.()) return true;
    const protocol = String(w.location?.protocol || '');
    return protocol === 'capacitor:' || protocol === 'file:';
  } catch {
    return false;
  }
}

const webBaseURL = String(import.meta.env.VITE_API_BASE_URL_WEB || '').trim();
const nativeBaseURL = String(import.meta.env.VITE_API_BASE_URL || '').trim();
const baseURL = isNativePlatform()
  ? nativeBaseURL || webBaseURL || 'http://10.0.2.2:8000'
  : webBaseURL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:4028');

export function wsUrl(pathname: string, params?: Record<string, string | number | boolean | null | undefined>): string {
  const http = new URL(baseURL);
  const wsProtocol = http.protocol === 'https:' ? 'wss:' : 'ws:';
  const ws = new URL(http.toString());
  ws.protocol = wsProtocol;
  ws.pathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      if (v === null || v === undefined) continue;
      ws.searchParams.set(k, String(v));
    }
  }
  return ws.toString();
}
